import React from 'react';
import SortableHeader from '../../SortableHeader';
import ScrollableStandingsRow from './ScrollableStandingsRow';

// eslint-disable-next-line import/no-extraneous-dependencies

function ScrollableStandingsTable({
  headers,
  // season,
  data,
  formShow,
  // dataLoading,
  sortable,
  sortKey,
  setSortKey,
  sortDirection,
  setSortDirection,
  isWidget,
}) {
  const [scrollbarIsVisible, setScrollbarIsVisible] = React.useState(false);

  const [showLeft, setShowLeft] = React.useState(false);
  const [showRight, setShowRight] = React.useState(false);
  const el = React.useRef(null);
  React.useEffect(() => {
    if (el.current) {
      setScrollbarIsVisible(el.current.scrollWidth > el.current.clientWidth);

      const resizeItemObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry) {
          const isVisible = entry.target.scrollWidth > entry.target.clientWidth;
          setScrollbarIsVisible(isVisible);
          setShowRight(isVisible);
        }
      });

      resizeItemObserver.observe(el.current);

      el.current.addEventListener('scroll', (e) => {
        setShowLeft(e.currentTarget.scrollLeft > 0);
        setShowRight(
          e.currentTarget.scrollLeft <
            e.currentTarget.scrollWidth - e.currentTarget.clientWidth
        );
      });
    }
  }, []);
  React.useEffect(() => {
    if (!scrollbarIsVisible) {
      setShowLeft(false);
      setShowRight(false);
    }
  }, [scrollbarIsVisible]);
  return (
    <div ref={el} className="standings-table-container">
      <table
        className={`standings-table ${
          isWidget ? 'standings-table--widget' : ''
        }`}
      >
        <tr className="standings-table--header">
          <td>
            {!isWidget ? (
              <span className="d-none d-lg-block">Ranking</span>
            ) : null}
          </td>
          <td>
            <div
              className={`standings-table__name ${
                showLeft ? 'standings-table--left-shadow' : ''
              }`}
            >
              Lag
            </div>
          </td>
          {formShow ? (
            <td>
              <div className="standings-table__form">Form</div>
            </td>
          ) : null}

          {headers
            .map((headerInfo) => {
              if (headerInfo.sortKey === 'pts') {
                return {
                  ...headerInfo,
                  className: `${headerInfo.className} ${
                    showRight ? 'standings-table--right-shadow' : ''
                  }`,
                };
              }

              return headerInfo;
            })
            .map((headerInfo) => (
              <SortableHeader
                key={`h-${headerInfo.sortKey}`}
                sortable={sortable !== false}
                sortKey={headerInfo.sortKey}
                classes={headerInfo.className}
                activeSortKey={sortKey}
                direction={sortDirection}
                setDirection={setSortDirection}
                setSortKey={setSortKey}
                label={headerInfo.label}
                shortLabel={headerInfo.shortLabel}
                Component="td"
              />
            ))}
        </tr>
        {data?.map((item) => (
          <ScrollableStandingsRow
            data={item}
            key={item.id}
            formShow={formShow}
            showLeft={showLeft}
            showRight={showRight}
            isWidget={isWidget}
          />
        ))}
      </table>
    </div>
  );
}
export default ScrollableStandingsTable;
